import { themeColors } from "../../themeColors";
/**
 * @file   src\mobile\pages\ViewClient.js
 * @brief  This file is responsible for view client section in agent dashboard
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ClientProfileData from "../components/ClientProfileData";
import TopHeader from "../components/common/TopHeader";
import ViewClientMenu from "../components/clientManagement/ViewClientMenu";
import ClientActionDropdown from "../components/ClientActionDropdown";
import "../styles/clients.scss";
import { getClientDetailsMobile } from "../../services/agentClientsService";
import { pageURLs } from "@/constants";
import { setBodyBackgroundGrey } from "../../helpers/common";
import { usePremium } from "@/hooks";
import BackLinkButton from "../components/BackLinkButton";

const ViewClient = (props) => {
  const location = useLocation();
  const clientId = location.state && location.state["clientId"];
  const navigate = useNavigate();
  const [clientDetails, setClientDetails] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const pageRefreshOnEditClient = async () => {
    setIsRefresh(true);
  };

  const { shouldToggleColor } = usePremium();

  useEffect(() => {
    setBodyBackgroundGrey();
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  useEffect(() => {
    loadClientDetails();
  }, [isRefresh]);

  const loadClientDetails = async () => {
    setIsRefresh(false);
    await getClientDetailsMobile(clientId)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setClientDetails(responseResult);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <div className="gitcha-main-wrapper client-management my-client-wrap">
      <div className="content-wrapper">
        <TopHeader
          variant={"threeComp"}
          outerClassname="bg-white"
          topClassName="w-100 top-three-comp-headerborder"
          bottomClassName="w-100"
        >
          <BackLinkButton
            role="button"
            shouldToggleColor={shouldToggleColor}
            onClick={() => navigate(pageURLs.agentClientListing)}
          />
          <div className={shouldToggleColor ? "heading-premium" : "heading"}>
            View Client
          </div>
          <div className="right-mobbtn-wrap">
            <div className="social-btns-wrap">
              <ClientActionDropdown
                clientDetails={clientDetails.clientDetails}
                onEditComplete={pageRefreshOnEditClient}
              />
            </div>
          </div>
        </TopHeader>
        <div className="inner-layout-content-new">
          <ClientProfileData clientDetails={clientDetails.clientDetails} />
          <ViewClientMenu
            wantAdCount={clientDetails.wantAdCount}
            inventoryCount={clientDetails.inventoryCount}
            favoriteCount={clientDetails.favorite_Count}
            clientId={clientId}
            clientName={
              clientDetails.clientDetails?.FirstName +
              " " +
              clientDetails.clientDetails?.LastName
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ViewClient;
